import { object, string, boolean } from 'yup';
import addEmailValidation from '@afosto/utils-react/validators/validEmail';

addEmailValidation();

export default object().shape({
  useEmail: boolean(),
  useSms: boolean(),
  email: string().validEmail().when('useEmail', {
    is: true,
    then: string().required(),
  }),
  sms: string().when('useSms', {
    is: true,
    then: string().required(),
  }),
  atLeastOneMethod: boolean().when(['useEmail', 'useSms'], {
    is: (useEmail, useSms) => (!useEmail && !useSms) || (!!useEmail && !!useSms),
    then: boolean().required(),
  }),
});
